import React, { useEffect,useRef  } from "react";
import { ProductViewContainer } from "../../../../components/Widgets/ProductViewContainer";
import LabelCard from "../../../../components/Widgets/Cards/LabelCard";
import { useMountEffect } from 'primereact/hooks';
import { Messages } from 'primereact/messages';
import UploadProductCsvToolbar from "../../../../components/Widgets/Toolbars/UploadProductCsvToolbar";

const InventoryPage = ({setActivePath}) => {
  const msgs = useRef(null);

    useEffect(() => {
        setActivePath("Manage Inventory");
      }, [setActivePath]);

      useMountEffect(() => {
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show([
                { sticky: true, severity: 'warn', summary: 'Warning', detail: '186 products are out of stock!' },
            ]);
        }
    });

  return (
    <div className="outlet-container">
      
      <UploadProductCsvToolbar/>
      <Messages ref={msgs}/>
      <br/>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-[100%] mt-20">
        <LabelCard name="Total" quantity="24" footer="since last visit"/>
        <LabelCard name="In stock" quantity="24" footer="since last visit"/>
        <LabelCard name="Out of stock" quantity="24" footer="since last visit"/>
        <LabelCard name="Disabled" quantity="24" footer="since last visit"/>
      </div><br/>
      <span className="block text-500 font-medium mb-3">
                All products
                </span>
       <ProductViewContainer/>
     
    </div>
  )
}


export default InventoryPage
